import axios from 'axios'
import { toast } from 'react-toastify'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))
export default { 
    
    getSafetyStock: (idToken, type, id) => new Promise((resolve, reject) => {
        instance.post(
            '/safety/stock',
            {
                type: type,
                id: id
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            
        })
    }),

    getSafetyStockRegister: (idToken, type, id) => new Promise((resolve, reject) => {
        instance.post(
            '/safety/register',
            {
                init: true,
                id: id
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        }).catch(error => {
                reject(error)
        })
    }),

    CrudSafetyStockRegister: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/safety/register',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                toast.success('Operacão realizada com sucesso!')
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        }).catch(error => {
            reject(error.response.data.errorMessage)
        })
    }),

    getSafetyStockPlanning: (idToken) => new Promise((resolve, reject) => {
        instance.post(
            '/safety/planning',
            {
                init: true,
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        }).catch(error => {
                reject(error)
        })
    }),

    crudSafetyStockPlanning: (idToken, data) => new Promise((resolve, reject) => {
        instance.post(
            '/safety/planning',
            {
                data
            },
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                toast.success('Operacão realizada com sucesso!')
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        }).catch(error => {
                reject(error.response.data.errorMessage)
        })
    })

}